import React, { useEffect, useState } from "react";
import { ButtonType } from "@components/atoms/Button/types";
import { Spacer, VDBText } from "@components/atoms";
import styled, { css, useTheme } from "styled-components/native";
import {
  Dimensions,
  Keyboard,
  Platform,
  TouchableOpacity,
  View,
} from "react-native";
import { useSelector } from "react-redux";
import {
  setLoginModalType,
  updateLastLoginDetails,
} from "@redux/slices/appStateSlice";
import {
  useCheckUserActivation,
  useSendEmailVerification,
  useSignIn,
  useUserMfaSendOtp,
} from "@apis/user";
import Routes from "@navigations/Routes";
import { navigate } from "@navigations/utils/RootNavigation";
import ApiRoutes from "@apis/routes";
import {
  setCompanyLocations,
  setIsGuest,
  setUserInfo,
  useUserInfo,
} from "@redux/slices/userInfoSlice";
import { useTranslation } from "react-i18next";
import BiometricAuthenticationButton from "@scenes/authentication/utils/Biometrics/BiomtericsButton";
import { messageType } from "@components/molecules/PopUp/types";
import { SpaceType } from "@components/atoms/Spacer/types";
import Logo from "@components/atoms/Logo";
import Popup from "@components/molecules/PopUp";
import { showToast, ToastTypes } from "@components/molecules/VDBToast/util";
import { getFromSecureStore, saveInSecureStore } from "../../utils";
import * as LocalAuthentication from "expo-local-authentication";
import { useThemeTokens } from "@apis/themeTokens";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { useOrgSettingsSlice } from "@redux/slices/orgSettingsSlice";
import { UserActivation, UserActivationData } from "@src/types/UserActivation";
import { ThemeTokenTypes } from "@scenes/splash-screen/types";
import { usePdpLayoutData } from "@apis/pdpCustomization";
import { useNavigationMenu } from "@apis/navigationMenu";
import { DefaultThemeValueType } from "../../../styled";
import VDBFooter from "@components/atoms/VDBFooter";
import { useFiltersData } from "@apis/filtersData";
import { setSharedActivationData } from "@scenes/authentication/NativeRegistration/context/RegistrationContext";
import { useSearchResultsCustomization } from "@apis/searchResultsCustomization";
import { useSplashScreenController } from "@scenes/splash-screen/utils";
import { appConfig } from "@utils/analytics";
import { useDispatch } from "react-redux";
import { useLoadTranslations } from "@apis/config";
import initializeI18n from "@i18n/index";
import { useOrgSettings } from "@apis/orgSettings";
import { KeyboardAwareScrollView } from "react-native-keyboard-controller";
import {
  useAppSettings,
  useGlobalData,
  useRegistrationFormMandatoryFlowCountry,
} from "@redux/slices/globalSlice";
import { useIsPublicAccessRestricted } from "@utils/usePrivateAppGuard";
import { useGetGlobalData } from "@apis/globalData";
import { AuthForm } from "./utils/components/AuthForm";
import { PopupAlert } from "@scenes/onboarding/utils/components/PopupAlert";
import SEOTags from "@components/atoms/SEOTags/SeoTags";
import { useUnifiedProductPagesData } from "@apis/useUnifiedProductPagesData";
import { OneSignal } from "react-native-onesignal";
import { useUserAnalytics } from "../../hooks/useAnalytics";
import Modal from "@components/atoms/Modal";
import EnterOtpForm from "./utils/components/EnterOtpForm";
import ActiveSessionList from "./utils/components/ActiveSessionList";
import { OtpFormDetails } from "./utils/Types/types";
import * as Device from "expo-device";
import { isMfaExpired, parseUserAgent } from "./utils/utils";
import { User } from "@src/types/user";
import IntercomClient from "@utils/IntercomClient";
import LayoutContainer from "@components/layout/LayoutContainer";
import { formatOSName } from "../../hooks/useAnalytics";
import { ResetHereToastMessage } from "@components/molecules/ResetHereToastMessage";
import { useGetCountryFromIp } from "./NativeRegistration/services/registrationApi";
//import crashlytics from "@react-native-firebase/crashlytics";

const AuthenticationScreen = ({
  route,
  renderAsChild,
  fromModal,
  proceedWithoutLoginFromModalPress,
}: any) => {
  const typography = useTypographyStore();
  const dispatch = useDispatch();
  const { _identify } = useUserAnalytics();
  const { t } = useTranslation();
  const theme = useTheme();
  const OverLayContainer =
    fromModal || theme.isLargeScreen || theme.isTablet ? View : LayoutContainer;
  const installationIdentifier = useSelector(
    (state: any) => state.appState?.installationIdentifier
  );
  const lastLoginDetails = useSelector(
    (state: any) => state.appState?.lastLoginDetails
  );
  const userInfo = useUserInfo();
  const deviceHeight = Dimensions.get("window").height;
  //redux slices
  const { settings } = useOrgSettingsSlice();
  const [authToken, setAuthToken] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [username, setUsername] = useState<string>("");
  const [usernameFormValue, setUsernameFormValue] = useState<string>("");
  const [formPassword, setFormPassword] = useState<string>("");
  const [rememberMeChecked, setRememberMeChecked] = useState(false);
  const [checkActivationData, setCheckActivationData] = useState(null);
  const [activeSessionsDetails, setActiveSessionsDetails] = useState({
    isOpen: false,
    reachActiveSessionLimit: false,
    user_id: "",
    email: "",
  });

  const [otpFormDetails, setOtpFormDetails] = useState<OtpFormDetails>({
    user_id: "",
    email: "",
    password: "",
    isOtpFormOpened: false,
  });

  const [loginActivated, setLoginActivated] = useState(false);
  const [showPopUpDialog, setShowPopUpDialog] = useState(false);
  const [popUpTitleMessage, setPopUpTitleMessage] = useState("error");
  const [themeTokensUrl, setThemeTokensUrl] = useState(ApiRoutes.THEME_TOKENS);
  const [isNavigationApiEnabled, setIsNavigationApiEnabled] = useState(false);
  const [navigationUrl, setNavigationUrl] = useState(ApiRoutes.NAVIGATION_MENU);
  const [isUnifiedProductPagesApiEnabled, setIsUnifiedProductPagesApiEnabled] =
    useState(false);
  const [unifiedProductPagesUrl, setUnifiedProductPagesUrl] = useState(
    ApiRoutes.UNIFIED_PRODUCT_PAGES_API
  );
  const [globalUrl, setGlobalURL] = useState(ApiRoutes.GLOBAL);
  const [isGlobalApiEnabled, setIsGlobalApiEnabled] = useState(false);
  const [pdpUrl, setPDPUrl] = useState(ApiRoutes.PDP_API);
  const [searchFromUrl, setSearchFromUrl] = useState(ApiRoutes.SEARCH_FORM_API);
  const [translationUrl, setTranslationUrl] = useState(ApiRoutes.TRANSLATIONS);
  const [searchResultUrl, setSearchResultUrl] = useState(
    ApiRoutes.SEARCH_RESULT_API
  );
  const { loginSubTitle } = useGlobalData();
  const showLoginSubTitle = loginSubTitle?.enable === true;
  const PLATFORM = Platform.OS === "web" ? 0 : 1;
  const orgSettings = useOrgSettings(PLATFORM);

  const [isThemeTokenApiEnabled, setIsThemeTokenApiEnabled] = useState(false);
  const [popUpMessageType, setPopUpMessageType] = useState<string>(
    messageType.Error
  );
  const [popUpContentBody, setPopUpContentBody] = useState({
    html: `<p></p>`,
  });

  const [verifyEmail, setVerifyEmail] = useState<string>("");
  const [emailVerificationPopUp, setEmailVerificationPopUp] = useState(false);
  const [validationPopUp, setValidationPopUp] = useState(false);
  const [pdpEnable, setPDPEnable] = useState(false);
  const [searchFormEnable, setSearchFromEnable] = useState(false);
  const [searchTranslationEnable, setTranslationEnable] = useState(false);
  const [searchResultEnable, setSearchResultEnable] = useState(false);
  const { showSplashScreen, hideSplashScreen } = useSplashScreenController();
  const [userData, setUserData] = useState<any>();
  const getAppSettings = useAppSettings();
  const { restrictPublicLogin } = useIsPublicAccessRestricted();
  const isWeb = process.env.EXPO_PUBLIC_PLATFORM === "web";
  const mfaSendOtp = useUserMfaSendOtp();
  const { data: countryData } = useGetCountryFromIp();
  const registrationFormMandatoryFlowCountry =
    useRegistrationFormMandatoryFlowCountry();
  const userCheckActivation = useCheckUserActivation(
    loginActivated ? username : "",
    loginActivated ? formPassword : ""
  );
  const signIn = useSignIn();
  const sendEmailVerification = useSendEmailVerification(verifyEmail);
  const themeTokensApiCall = useThemeTokens(
    themeTokensUrl,
    isThemeTokenApiEnabled,
    ThemeTokenTypes.COMPANY
  );
  const deviceDetails =
    Platform.OS === "web"
      ? parseUserAgent(navigator.userAgent)
      : {
          deviceName: Device.deviceName,
          osName: formatOSName(Platform.OS),
        };

  const themeNavigationApiCall = useNavigationMenu(
    navigationUrl,
    isNavigationApiEnabled,
    ThemeTokenTypes.COMPANY
  );

  const globalApiCall = useGetGlobalData(
    globalUrl,
    isGlobalApiEnabled,
    ThemeTokenTypes.COMPANY
  );

  const themePDPApiCall = usePdpLayoutData(
    pdpUrl,
    pdpEnable,
    ThemeTokenTypes.COMPANY
  );

  const searchFromApiCall = useFiltersData(
    searchFromUrl,
    searchFormEnable,
    ThemeTokenTypes.COMPANY
  );

  const searchResultApiCall = useSearchResultsCustomization(
    searchResultUrl,
    searchResultEnable,
    ThemeTokenTypes.COMPANY
  );

  const translationApiCall = useLoadTranslations(
    translationUrl,
    searchTranslationEnable
  );

  const unifiedProductPagesApiCall = useUnifiedProductPagesData(
    unifiedProductPagesUrl,
    isUnifiedProductPagesApiEnabled,
    ThemeTokenTypes.COMPANY
  );

  const closePopup = () => {
    //funtion to close the popup
    setShowPopUpDialog(false);
  };

  const [popUpActionBtns, setPopUpActionBtns] = useState([
    //buttons defined for the popup component
    {
      type: ButtonType.primary,
      title: t("authorization.alert.button.text"),
      onPressAction: closePopup,
    },
    {
      type: ButtonType.secondary,
      title: t("authorization.skipForNow.text"),
      onPressAction: () => {},
    },
  ]);

  useEffect(() => {
    setVerifyEmail("");

    const { isSuccess, data } = sendEmailVerification;
    if (isSuccess && data) {
      const message = data.data?.message;
      setEmailVerificationPopUp(false);
      if (message) {
        showToast(
          undefined,
          message,
          ToastTypes.SUCCESS,
          true,
          true,
          Platform.OS === "web" && theme.isMobile ? 100 : 40
        );
      }
    }
  }, [sendEmailVerification.isSuccess, sendEmailVerification.data]);

  const handleVerification = () => {
    setVerifyEmail(usernameFormValue);
  };

  const handleValidationPopUp = () => {
    setValidationPopUp(false);
  };

  const closeVerificationPopUp = () => {
    setEmailVerificationPopUp(false);
  };

  const handleUserActivationResponse = async (response: UserActivation) => {
    // setUsername("");
    setLoginActivated(false);
    if (response != null) {
      const { status, message, data: activationData } = response;
      if (status === 404) {
        setIsLoading(false);
        showToast(messageType.Error, message, messageType.Error, true, true);
      } else if (activationData != null) {
        setCheckActivationData(activationData);
        await handleActivationData(activationData, message);
      }
    }
  };

  const handleActivationData = async (
    activationData: UserActivationData,
    message: string
  ) => {
    if (activationData.user_status === "deactivated") {
      showAccountDeactivatedPopup(message);
      setIsLoading(false);
    } else if (activationData.user_status === "deleted") {
      showAccountDeletedPopup();
      setIsLoading(false);
    } else if (message === "Success") {
      await handleSuccessfulMessage(activationData);
    }
  };

  const showAccountDeactivatedPopup = (message: string) => {
    setPopUpMessageType(messageType.Error);
    setPopUpTitleMessage(t("authorization.accountDeactivated.text"));
    setPopUpContentBody({
      html:
        message ??
        t("authorization.accountDeactivatedMessage.text", {
          support_email: settings.organization.emails.support,
        }),
    });
    setPopUpActionBtns([
      {
        type: ButtonType.primary,
        title: t("authorization.alert.button.text"),
        onPressAction: closePopup,
      },
    ]);
    setShowPopUpDialog(true);
  };

  const showAccountDeletedPopup = () => {
    setPopUpMessageType(messageType.Error);
    setPopUpTitleMessage(t("login.deletedUser.toast.title.text"));
    setPopUpContentBody({
      html: t("login.deletedUser.toast.description.text"),
    });
    setPopUpActionBtns([
      {
        type: ButtonType.primary,
        title: t("authorization.alert.button.text"),
        onPressAction: closePopup,
      },
    ]);
    setShowPopUpDialog(true);
  };

  const sendMfaOtp = async (activationData: any) => {
    mfaSendOtp.mutate(
      {
        user_id: activationData?.user_id,
        password: formPassword,
      },
      {
        async onSuccess() {
          setOtpFormDetails({
            email: activationData.email_address,
            user_id: activationData.user_id,
            isOtpFormOpened: true,
            password: formPassword,
          });
        },
        onError(error) {
          console.log("Error sending OTP:", error);
        },
      }
    );
  };

  const handleMfaOtpSuccess = async (isSuccess: boolean) => {
    setOtpFormDetails({
      email: "",
      user_id: null,
      isOtpFormOpened: false,
      password: "",
    });
    Platform.OS !== "web" && Keyboard.dismiss();
    if (isSuccess) {
      if (checkActivationData?.reach_active_session_limit) {
        setActiveSessionsDetails((prev) => ({
          ...prev,
          reachActiveSessionLimit: true,
          isOpen: true,
        }));
        setIsLoading(false);
      } else {
        setIsLoading(true);
        setUsername("");
        await signInUser();
      }
    } else setIsLoading(false);
  };

  const handleActiveSessionLogoutSuccess = async (isSuccess: boolean) => {
    if (isSuccess) {
      setUsername("");
      setIsLoading(true);
      await signInUser();
    } else {
      setCheckActivationData(null);
    }
    setActiveSessionsDetails({
      isOpen: false,
      reachActiveSessionLimit: false,
      user_id: "",
      email: "",
    });
  };

  /**
   * Handles redirection for incomplete registration based on registration_status
   * Returns true if registration redirect was handled, false otherwise
   */
  const handleRegistrationRedirect = (
    activationData: UserActivationData
  ): boolean => {
    const { registration_status, activation_status } = activationData;

    // If no registration_status or null, continue with normal flow
    if (!registration_status || activation_status) {
      return false;
    }

    switch (registration_status) {
      case "acct_cr":
        // Step 1 done → Redirect to Step 2 (company details / native registration).
        // Token and activation data stay in the session store, not route params.
        setSharedActivationData(activationData);
        navigate(Routes.Register, {
          fromLogin: true,
          resumeStep: 2,
        });
        setIsLoading(false);
        return true;

      case "comp_prf":
        // Step 2 done → Redirect to Application Status / Document Upload
        setSharedActivationData({
          ...activationData,
          document_upload_mandatory:
            registrationFormMandatoryFlowCountry.includes(
              activationData?.country as string
            ) ?? false,
        });

        navigate(Routes.ApplicationStatus);
        setIsLoading(false);
        return true;

      case "app_vrf":
        // Step 3 done → Redirect to Application Status
        setSharedActivationData({
          ...activationData,
          document_upload_mandatory:
            registrationFormMandatoryFlowCountry.includes(
              countryData?.data?.data?.getCountryFromIP?.[0]?.country
            ) ?? false,
        });
        navigate(Routes.ApplicationStatus);
        setIsLoading(false);
        return true;

      default:
        return false;
    }
  };

  const handleSuccessfulMessage = async (
    activationData: UserActivationData
  ) => {
    // First check for incomplete registration and handle redirect
    if (handleRegistrationRedirect(activationData)) {
      return;
    }

    // Continue with existing flow if registration is complete or not applicable
    if (!activationData.email_verified_status) {
      setEmailVerificationPopUp(true);
      setIsLoading(false);
    } else if (!activationData.activation_status) {
      setValidationPopUp(true);
      setIsLoading(false);
    } else if (activationData?.mfa_enabled) {
      if (!activationData.is_password_correct) {
        showIncorrectPasswordToastMessage(
          t(
            "login.incorrectPassword.toastMessage.text",
            "Password is incorrect. Please try again or {{reset_here}}"
          )
        );
        setIsLoading(false);
      } else {
        const userLastLoginDetails =
          lastLoginDetails && lastLoginDetails.length
            ? lastLoginDetails.find(
                (user: any) => user.user_id === activationData.user_id
              )
            : null;
        if (userLastLoginDetails && userLastLoginDetails?.timestamp) {
          if (!isMfaExpired(userLastLoginDetails)) {
            if (activationData.reach_active_session_limit) {
              _identify(`${activationData?.user_id}`, {
                email: activationData?.email_address,
                ...appConfig,
              }).then();
              setActiveSessionsDetails((prev) => ({
                ...prev,
                reachActiveSessionLimit: true,
                isOpen: true,
              }));
            } else {
              setUsername("");
              await signInUser();
            }
            setIsLoading(false);
          } else {
            _identify(`${activationData?.user_id}`, {
              email: activationData?.email_address,
              ...appConfig,
            }).then();
            sendMfaOtp(activationData);
          }
        } else {
          _identify(`${activationData?.user_id}`, {
            email: activationData?.email_address,
            ...appConfig,
          }).then();
          sendMfaOtp(activationData);
        }
      }
    } else {
      setUsername("");
      await signInUser();
    }
  };

  const showIncorrectPasswordToastMessage = (message: string) => {
    resetHereToast(message);
  };

  const resetHereToast = (message: string) => {
    if (message && message.includes("{{reset_here}}")) {
      const errorMessage = (
        <ResetHereToastMessage
          message={message}
          navigation={navigation}
          userInfo={userInfo}
          username={username}
          t={t}
        />
      );

      showToast(
        "Error",
        errorMessage,
        ToastTypes.ERROR,
        true,
        true,
        Platform.OS === "web" && theme.isMobile ? 100 : 40
      );
    }
  };

  const signInUser = async (token?: string) => {
    signIn.mutate(
      {
        ...(token
          ? { public_token: token }
          : { username: username, password: formPassword }),
        installation_identifier: installationIdentifier,
        device_info: deviceDetails,
      },
      {
        async onSuccess(data) {
          const user = data.data.user;
          await Promise.all([
            saveInSecureStore({
              remember_me: rememberMeChecked ? "true" : "false",
              username,
              password: formPassword,
            }),
          ]);

          const userLastLoginDetails =
            lastLoginDetails && lastLoginDetails.length
              ? lastLoginDetails.find((_user: any) => _user.user_id === user.id)
              : null;
          if (
            checkActivationData?.mfa_enabled &&
            isMfaExpired(userLastLoginDetails)
          ) {
            dispatch(
              updateLastLoginDetails({
                user_id: user.id,
              })
            );
          }
          if (!theme.isLargeScreen && restrictPublicLogin) {
            dispatch(setUserInfo({ ...userInfo.user, id: null }));
          }
          await handleSignInSuccess(user, !!token);
        },
        onError(error) {
          if (error) {
            showIncorrectPasswordToastMessage(error?.response?.data?.message);
          }
          setIsLoading(false);
        },
      }
    );
  };

  useEffect(() => {
    const isNavigationSuccess = isNavigationApiEnabled
      ? isNavigationApiEnabled && themeNavigationApiCall.isSuccess
      : true;

    const isPDPSuccess = pdpEnable
      ? pdpEnable && themePDPApiCall.isSuccess
      : true;

    const isSearchFormSuccess = searchFormEnable
      ? searchFormEnable && searchFromApiCall.isSuccess
      : true;

    const isSearchResultSuccess = searchResultEnable
      ? searchResultEnable && searchResultApiCall.isSuccess
      : true;

    const isThemeTokenSuccess = isThemeTokenApiEnabled
      ? isThemeTokenApiEnabled && themeTokensApiCall.isSuccess
      : true;

    const isTranslationSuccess = searchTranslationEnable
      ? searchTranslationEnable && translationApiCall.isSuccess
      : true;
    const isGlobalSuccess = isGlobalApiEnabled
      ? isGlobalApiEnabled && globalApiCall.isSuccess
      : true;
    const isUnifiedProductPagesSuccess = isUnifiedProductPagesApiEnabled
      ? isUnifiedProductPagesApiEnabled && unifiedProductPagesApiCall.isSuccess
      : true;

    if (
      themeNavigationApiCall.isError ||
      themePDPApiCall.isError ||
      searchFromApiCall.isError ||
      searchResultApiCall.isError ||
      themeTokensApiCall.isError ||
      globalApiCall.isError
    ) {
      hideSplashScreen();
    }
    const allApisSuccessful =
      isNavigationSuccess &&
      isPDPSuccess &&
      isSearchFormSuccess &&
      isSearchResultSuccess &&
      isThemeTokenSuccess &&
      isUnifiedProductPagesSuccess &&
      isTranslationSuccess &&
      isGlobalSuccess &&
      authToken;

    if (allApisSuccessful && userData) {
      const user = userData;
      dispatch(setUserInfo(user));
      if (user?.company_locations?.length > 0) {
        dispatch(setCompanyLocations(user.company_locations));
      }
      _identify(`${user?.id}`, {
        name: `${user?.first_name} ${user?.last_name}`,
        email: user?.email,
        country: user?.country,
        ...appConfig,
      }).then();

      if (isWeb && Platform.OS === "web") {
        if (typeof window !== "undefined" && window.DD_RUM?.setUser) {
          window.DD_RUM.onReady(function () {
            window.DD_RUM.setUser({
              id: `${user?.id}`,
              name: `${user?.first_name} ${user?.last_name}`,
              email: user?.email,
              extraInfo: {
                country: user?.country,
                price_mode: user?.price_mode,
                user_company_id: user?.company_id,
                user_company_name: user?.company,
                user_organization_id: settings?.organization?.id?.toString(),
                user_organization_name:
                  settings?.organization?.name?.toString(),
              },
            });
          });
        }
      }
      OneSignal.User.addTags({
        user_id: String(user?.id ?? ""),
        device_type: theme.isMobile
          ? "mobile"
          : theme.isTablet
          ? "ipad"
          : "desktop",
        pro_user: user?.custom_theme ? "true" : "false",
      });

      if (!user?.accepted_terms && !user?.iframe_status) {
        hideSplashScreen();
        navigate(Routes.TermsAndConditions);
      }
      const currentLanguage = user?.locale ?? "en";
      initializeI18n(translationApiCall?.data?.data, currentLanguage);
      dispatch(setLoginModalType("none"));
      setIsLoading(false);
    }
  }, [
    isNavigationApiEnabled,
    pdpEnable,
    searchFormEnable,
    searchResultEnable,
    isThemeTokenApiEnabled,
    isGlobalApiEnabled,
    globalApiCall.isSuccess,
    themeNavigationApiCall.isSuccess,
    themePDPApiCall.isSuccess,
    searchFromApiCall.isSuccess,
    searchResultApiCall.isSuccess,
    translationApiCall.isSuccess,
    themeTokensApiCall.isSuccess,
    unifiedProductPagesApiCall.isSuccess,
    authToken,
    userData,
  ]);

  const handleSignInSuccess = async (user: User, isGuest: boolean) => {
    showSplashScreen();

    dispatch(setIsGuest(isGuest));
    if (user.json_navigation_menus) {
      setNavigationUrl(user.json_navigation_menus);
      setIsNavigationApiEnabled(true);
    }
    if (user.global) {
      setGlobalURL(user.global);
      setIsGlobalApiEnabled(true);
    }
    if (user.pdps) {
      setPDPUrl(user.pdps);
      setPDPEnable(true);
    }
    if (user?.search_forms) {
      setSearchFromUrl(user.search_forms);
      setSearchFromEnable(true);
    }

    if (user.custom_texts) {
      setTranslationUrl(user.custom_texts);
      setTranslationEnable(true);
    }

    if (user?.search_results) {
      setSearchResultUrl(user.search_results);
      setSearchResultEnable(true);
    }
    if (user.custom_theme) {
      setThemeTokensUrl(
        theme.isLargeScreen ? user.web_token_file : user.mobile_token_file
      );
      setIsThemeTokenApiEnabled(true);
    }

    if (user.product_unified_pages) {
      setUnifiedProductPagesUrl(user.product_unified_pages);
      setIsUnifiedProductPagesApiEnabled(true);
    }
    await handleBiometricAuthentication();
    if (Platform.OS === "web") {
      localStorage.setItem("userData", JSON.stringify(user));
      localStorage.setItem("installation_identifier", installationIdentifier);
      localStorage.setItem("token", user.token);
    }
    setAuthToken(user.token);
    setUserData(user);
    if (user?.show_intercom_key && user) {
      if (Platform.OS === "web") {
        IntercomClient.loginUser(
          user?.show_intercom_key,
          user?.id?.toString(),
          user?.email,
          user?.name,
          user?.created_at,
          {
            plan: "Pro",
            account_type: "enterprise",
            usage: 1340,
          }
        );
      }
    }
  };

  const handleBiometricAuthentication = async () => {
    const usernameAlreadySaved = await getFromSecureStore("username");
    let biometricEnabled = await getFromSecureStore("biometricEnabled");
    if (!usernameAlreadySaved) {
      let result = false;

      if (Platform.OS !== "web") {
        await LocalAuthentication.authenticateAsync();
        result = await LocalAuthentication.isEnrolledAsync();
      }

      biometricEnabled = result ? "true" : "false";
      await saveInSecureStore({ biometricEnabled });
    }
  };

  useEffect(() => {
    if (userCheckActivation.isFetching) return;
    // setUsername("");
    if (userCheckActivation.isSuccess) {
      const userActivationResponse = userCheckActivation.data?.data;
      handleUserActivationResponse(userActivationResponse);
    } else if (userCheckActivation.isError) {
      setIsLoading(false);
      setLoginActivated(false);
    }
  }, [
    userCheckActivation.isSuccess,
    userCheckActivation.isError,
    userCheckActivation.isFetching,
  ]);

  const scrollToTop = () => {
    window.scroll({
      top: 0,
      behavior: "smooth",
    });
  };

  const onSubmit = (data: any) => {
    if (Platform.OS === "web" && !theme.isLargeScreen) {
      scrollToTop();
    }
    Keyboard.dismiss();
    setUsername(data.username);
    setFormPassword(data.password);
    setLoginActivated(true);
    setIsLoading(true);
  };

  const handleBiometricLoginSuccess = async () => {
    const storeUsername = await getFromSecureStore("username");
    const storePassword = await getFromSecureStore("password");
    if (storeUsername != null && storePassword != null) {
      setUsername(storeUsername);
      setFormPassword(storePassword);
      setLoginActivated(true);
    }
  };

  const onProceedWithoutLoginPress = async () => {
    setIsLoading(true);
    signInUser(orgSettings.data?.data?.organization?.settings?.public_key).then(
      () => {
        dispatch(setIsGuest(true));
      }
    );
  };

  const registerOnPress = () => {
    if (userInfo.isGuest) {
      navigate(Routes.GlobalNavigator, {
        headerShown: "true",
        screen: Routes.Register,
        params: {
          fromGlobal: true,
        },
      });
      dispatch(setLoginModalType("none"));
    } else {
      navigate(Routes.Register);
    }
  };

  return (
    <OverLayContainer
      style={renderAsChild && theme.isTablet ? { flex: 1 } : undefined}
    >
      <SEOTags routeName={Routes.Authentication} />
      <ParentContainer
        theme={theme}
        style={renderAsChild && theme.isTablet ? { flex: 1 } : undefined}
      >
        <Overlay
          deviceHeight={deviceHeight}
          renderAsChild={renderAsChild}
          tabletChild={renderAsChild && theme.isTablet}
        >
          <KeyboardAwareScrollView
            extraKeyboardSpace={20}
            bottomOffset={theme.isTablet ? 80 : 36}
            keyboardShouldPersistTaps={"handled"}
            contentContainerStyle={{ flexGrow: 1 }}
            alwaysBounceHorizontal={false}
            alwaysBounceVertical={false}
            bounces={false}
            showsVerticalScrollIndicator={false}
            showsHorizontalScrollIndicator={false}
          >
            {!theme.isLargeScreen && <Spacer size={SpaceType.Big} />}
            <LogoView>
              <Logo height={130} width={256} />
            </LogoView>
            <Spacer size={SpaceType.ExtraLarge} />
            {showLoginSubTitle && (
              <>
                <VDBText
                  color={theme["core-05"]}
                  style={typography["H3-M"]}
                  textAlign="center"
                >
                  {t("login.subTitle.title.text")}
                </VDBText>
                <Spacer size={SpaceType.ExtraLarge} />
              </>
            )}
            <AuthForm
              onSubmit={onSubmit}
              isLoading={isLoading}
              rememberMeChecked={rememberMeChecked}
              setRememberMeChecked={setRememberMeChecked}
              username={username}
              setUsername={setUsername}
              setUsernameFormValue={setUsernameFormValue}
              setFormPassword={setFormPassword}
            />

            {showPopUpDialog && (
              <Popup
                type={popUpMessageType}
                title={popUpTitleMessage}
                buttons={popUpActionBtns}
                HtmlSource={popUpContentBody}
                styleKey="Body-R"
              />
            )}
            {Platform.OS !== "web" && (
              <BiometricsView>
                <BiometricAuthenticationButton
                  onBiometricLoginSuccess={handleBiometricLoginSuccess}
                />
              </BiometricsView>
            )}
            <Spacer size={SpaceType.ExtraLarge} />
            {!getAppSettings?.sepraseSignUpLink && (
              <RegisterContainer>
                <LeftTextContainer>
                  <VDBText
                    color={theme["core-06"]}
                    style={typography["Body-R"]}
                  >
                    {t("login.screenText.notAMember.text")}
                  </VDBText>
                </LeftTextContainer>

                <TouchableOpacity onPress={registerOnPress}>
                  <VDBText
                    color={theme["link-static"]}
                    style={typography["Body-M"]}
                  >
                    {t("login.linkButton.signUpHere.text")}
                  </VDBText>
                </TouchableOpacity>
              </RegisterContainer>
            )}

            {orgSettings.data?.data?.organization?.settings
              ?.allow_public_login &&
              !restrictPublicLogin && (
                <RegisterContainer>
                  <TouchableOpacity
                    onPress={() =>
                      fromModal
                        ? proceedWithoutLoginFromModalPress()
                        : onProceedWithoutLoginPress()
                    }
                  >
                    <Spacer size={SpaceType.ExtraLarge} />
                    <VDBText color={theme["link-static"]}>
                      {t("login.linkButton.proceedWithoutLogin.text")}
                    </VDBText>
                  </TouchableOpacity>
                </RegisterContainer>
              )}

            <Spacer size={SpaceType.ExtraLarge} />

            <VDBFooter />

            <PopupAlert route={route} isRemovableFromStorage={true} />

            {emailVerificationPopUp && (
              <Popup
                type={messageType.Generic}
                title={t("login.emailVerification.popUp.title.text")}
                buttons={[
                  {
                    type: ButtonType.primary,
                    title: t(
                      "login.emailVerification.popUp.primaryButton.text"
                    ),
                    onPressAction: handleVerification,
                    loading: sendEmailVerification.isFetching,
                    disabled: sendEmailVerification.isFetching,
                  },
                  {
                    type: ButtonType.secondary,
                    title: t(
                      "login.emailVerification.popUp.secondaryButton.text"
                    ),
                    onPressAction: closeVerificationPopUp,
                  },
                ]}
                HtmlSource={{
                  html: t("login.emailVerification.popUp.discription.text", {
                    y: settings.organization.emails.system
                      ? settings.organization.emails.system
                      : "system@vdbapp.com",
                    z: settings.organization.emails.support
                      ? settings.organization.emails.support
                      : "support@vdbapp.com",
                  }),
                }}
                styleKey="Body-R"
              />
            )}
            {validationPopUp && (
              <Popup
                type={messageType.Error}
                title={t("login.accountValidation.popUp.title.text")}
                buttons={[
                  {
                    type: ButtonType.primary,
                    title: t("login.accountValidation.popUp.button.text"),
                    onPressAction: handleValidationPopUp,
                  },
                ]}
                HtmlSource={{
                  html: t("login.accountValidation.popUp.desciption.text"),
                }}
                styleKey="Body-R"
              />
            )}
            <Modal
              isOpen={otpFormDetails.isOtpFormOpened}
              onClose={() => handleMfaOtpSuccess(false)}
              headerTitle={t(
                "login.enterOtp.headerTitle.text",
                "Verify Your Account"
              )}
            >
              {otpFormDetails.isOtpFormOpened ? (
                <EnterOtpForm
                  onSuccess={handleMfaOtpSuccess}
                  email={otpFormDetails.email}
                  user_id={otpFormDetails.user_id}
                  password={otpFormDetails.password}
                />
              ) : null}
            </Modal>
            {activeSessionsDetails.isOpen &&
            activeSessionsDetails.reachActiveSessionLimit ? (
              <ActiveSessionList
                isOpen={
                  activeSessionsDetails.isOpen &&
                  activeSessionsDetails.reachActiveSessionLimit
                }
                onSuccess={handleActiveSessionLogoutSuccess}
                user_id={checkActivationData.user_id}
                password={formPassword}
              />
            ) : null}
          </KeyboardAwareScrollView>
        </Overlay>
      </ParentContainer>
    </OverLayContainer>
  );
};

const ParentContainer = styled.View<{
  theme?: DefaultThemeValueType;
}>`
  align-items: center;
  ${({ theme }) =>
    theme.isMobile &&
    css`
      padding-horizontal: 16px;
    `}
`;

const RegisterContainer = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const LeftTextContainer = styled.View`
  flex: 1;
  margin-right: 16px;
`;

const LogoView = styled.View`
  align-items: center;
`;
const Overlay = styled.View<any>`
  ${({ deviceHeight, renderAsChild, tabletChild }) =>
    tabletChild
      ? css`
          flex: 1;
        `
      : renderAsChild
      ? css`
          min-height: auto;
        `
      : css`
          min-height: ${deviceHeight}px;
        `}
  width: 100%;
  max-width: ${({ theme }) => (theme.isLargeScreen ? "343px" : "100%")};
`;

const BiometricsView = styled.View`
  justify-content: center;
  align-items: center;
`;

export default AuthenticationScreen;
